// Static event metadata shared by frontend + Worker. Live seat availability
// always comes from the API (/api/slots); these are the fixed facts/copy keys.

export const EVENT_TITLE_EN = "Park Bo-gum Happy Birthday 2026";
export const EVENT_TITLE_SHORT = "HBD Bogummy 16/6/2026";
export const CAFE_NAME = "Gumm&Kalee Café";

// Venue: "Gumm & Kalee" café (Song Wat, Bangkok). Both the link and the embed resolve to
// the named business (marker + shop name) instead of a bare Plus Code pin.
// - Link opens the exact place by its Google Place CID (from the venue's Maps URL).
// - Embed queries the venue's exact Google name so `output=embed` lands on the single
//   place (a non-exact name returns multiple search results).
export const MAPS_PLACE_CID = "17945207511845690472";
export const MAPS_PLACE_NAME = "Gumm & Kalee ทรงวาด";
export const MAPS_URL = `https://www.google.com/maps?cid=${MAPS_PLACE_CID}`;
export const MAPS_EMBED_URL = `https://maps.google.com/maps?q=${encodeURIComponent(MAPS_PLACE_NAME)}&output=embed`;

export const EVENT_SITE_URL = "https://bo-gum-bd.happication.com";
export const COMPANY = { name: "Happication Co., Ltd.", url: "https://happication.com" };

export type DayTheme = "day1" | "day2" | "day3";

export interface EventDay {
  date: string; // YYYY-MM-DD
  theme: DayTheme;
  giveawayQuota: number; // first N sets per round
  luckyDrawKey: "shirt" | "ginseng" | "shampoo";
}

// Order matters (Day 1/2/3).
export const EVENT_DAYS: EventDay[] = [
  { date: "2026-06-14", theme: "day1", giveawayQuota: 20, luckyDrawKey: "shirt" },
  { date: "2026-06-15", theme: "day2", giveawayQuota: 10, luckyDrawKey: "ginseng" },
  { date: "2026-06-16", theme: "day3", giveawayQuota: 10, luckyDrawKey: "shampoo" },
];

export interface RoundTime {
  round: number;
  start: string;
  end: string;
  checkInFrom: string; // 30 min before start
}

export const ROUND_TIMES: RoundTime[] = [
  { round: 1, start: "09:00", end: "12:00", checkInFrom: "08:30" },
  { round: 2, start: "12:00", end: "15:00", checkInFrom: "11:30" },
  { round: 3, start: "15:00", end: "18:00", checkInFrom: "14:30" },
];

export function themeForDate(date: string): DayTheme {
  return EVENT_DAYS.find((d) => d.date === date)?.theme ?? "day1";
}

export function roundLabel(start: string, end: string): string {
  return `${start}–${end}`;
}
